exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "main {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n}\n\nmain.darkMode {\n    background-color: black;\n}\n\nconsole {\n    -ms-flex-preferred-size: auto;\n        flex-basis: auto;\n    -ms-flex-negative: 1;\n        flex-shrink: 1;\n    -webkit-box-flex: 1;\n        -ms-flex-positive: 1;\n            flex-grow: 1;\n}\n\n@media (orientation:portrait) {\n    main {\n        display: block;\n    }\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Applications/MAMP/htdocs/interactive-board/client/src/app/app.style.css
// module id = ../../../../../src/app/app.style.css
// module chunks = main